import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const arrowIcon = (
  <span className="ml-2 inline-block transition-transform duration-200 ease-out group-hover:translate-x-2">
    <FontAwesomeIcon
      icon={faArrowRight}
      className="block transition-transform duration-300 ease-out delay-150 group-hover:-rotate-45"
    />
  </span>
);
export { arrowIcon };
